/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditBookingBodyBody,
    BookingCreateSuccessResponseResponse,
    BookingSuccessResponseResponse,
    BookingTicketPermissionsSuccessResponseResponse,
    BookingsSuccessResponseResponse,
    CancelBookingParams,
    ChangeBookingItemsParams,
    ChangeMassBookingItemsBodyBody,
    EditBookingCheckinBodyBody,
    EditBookingCheckinParams,
    EditBookingSuccessResponseResponse,
    FhDirectConnect200,
    FhDirectConnectBody,
    FhDirectDiscoverItems200,
    FhDirectDiscoverItemsBody,
    FhDirectImport200,
    FhDirectImportBody,
    FhDirectImportSeats200,
    FhDirectImportSeatsBody,
    FhDirectManifest200,
    FhDirectManifestBody,
    FhDirectVerify200,
    FhDirectVerifyBody,
    FhDirectVerifyFix200,
    FhDirectVerifyFixBody,
    GetBookingsParams,
    GetRefundChunksParams,
    ReSourceBookingBody,
    RefundBookingBodyBody,
    RefundBookingParams,
    RefundChunksSuccessResponseResponse,
    RequestStatusResponseResponse,
    SimpleRefundBookingParams,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new booking
 */
export const addBooking = (
    addEditBookingBodyBody: AddEditBookingBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<BookingCreateSuccessResponseResponse>({
        url: `/bookings`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditBookingBodyBody,
        signal,
    });
};

export const getAddBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addBooking>>,
        TError,
        { data: AddEditBookingBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addBooking>>,
    TError,
    { data: AddEditBookingBodyBody },
    TContext
> => {
    const mutationKey = ['addBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addBooking>>,
        { data: AddEditBookingBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addBooking(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddBookingMutationResult = NonNullable<Awaited<ReturnType<typeof addBooking>>>;
export type AddBookingMutationBody = AddEditBookingBodyBody;
export type AddBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Add new booking
 */
export const useAddBooking = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addBooking>>,
        TError,
        { data: AddEditBookingBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addBooking>>,
    TError,
    { data: AddEditBookingBodyBody },
    TContext
> => {
    const mutationOptions = getAddBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get bookings matching the filters
 */
export const getBookings = (params?: GetBookingsParams, signal?: AbortSignal) => {
    return customInstance<BookingsSuccessResponseResponse>({
        url: `/bookings`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetBookingsQueryKey = (params?: GetBookingsParams) => {
    return [`/bookings`, ...(params ? [params] : [])] as const;
};

export const getGetBookingsQueryOptions = <
    TData = Awaited<ReturnType<typeof getBookings>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetBookingsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookings>>> = ({ signal }) =>
        getBookings(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBookings>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getBookings>>>;
export type GetBookingsQueryError = APIErrorResponseResponse;

/**
 * @summary Get bookings matching the filters
 */

export function useGetBookings<
    TData = Awaited<ReturnType<typeof getBookings>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetBookingsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get refund chunks for a booking
 */
export const getRefundChunks = (
    id: number,
    params?: GetRefundChunksParams,
    signal?: AbortSignal,
) => {
    return customInstance<RefundChunksSuccessResponseResponse>({
        url: `/bookings/${id}/refundchunks`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetRefundChunksQueryKey = (id?: number, params?: GetRefundChunksParams) => {
    return [`/bookings/${id}/refundchunks`, ...(params ? [params] : [])] as const;
};

export const getGetRefundChunksQueryOptions = <
    TData = Awaited<ReturnType<typeof getRefundChunks>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetRefundChunksParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getRefundChunks>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRefundChunksQueryKey(id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefundChunks>>> = ({ signal }) =>
        getRefundChunks(id, params, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRefundChunks>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetRefundChunksQueryResult = NonNullable<Awaited<ReturnType<typeof getRefundChunks>>>;
export type GetRefundChunksQueryError = APIErrorResponseResponse;

/**
 * @summary Get refund chunks for a booking
 */

export function useGetRefundChunks<
    TData = Awaited<ReturnType<typeof getRefundChunks>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetRefundChunksParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getRefundChunks>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetRefundChunksQueryOptions(id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Refund booking/reservation
 */
export const refundBooking = (
    id: number,
    refundBookingBodyBody: RefundBookingBodyBody,
    params?: RefundBookingParams,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: refundBookingBodyBody,
        params,
        signal,
    });
};

export const getRefundBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof refundBooking>>,
        TError,
        { id: number; data: RefundBookingBodyBody; params?: RefundBookingParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof refundBooking>>,
    TError,
    { id: number; data: RefundBookingBodyBody; params?: RefundBookingParams },
    TContext
> => {
    const mutationKey = ['refundBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof refundBooking>>,
        { id: number; data: RefundBookingBodyBody; params?: RefundBookingParams }
    > = (props) => {
        const { id, data, params } = props ?? {};

        return refundBooking(id, data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type RefundBookingMutationResult = NonNullable<Awaited<ReturnType<typeof refundBooking>>>;
export type RefundBookingMutationBody = RefundBookingBodyBody;
export type RefundBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Refund booking/reservation
 */
export const useRefundBooking = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof refundBooking>>,
        TError,
        { id: number; data: RefundBookingBodyBody; params?: RefundBookingParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof refundBooking>>,
    TError,
    { id: number; data: RefundBookingBodyBody; params?: RefundBookingParams },
    TContext
> => {
    const mutationOptions = getRefundBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get booking by id
 */
export const getBooking = (id: number, signal?: AbortSignal) => {
    return customInstance<BookingSuccessResponseResponse>({
        url: `/bookings/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetBookingQueryKey = (id?: number) => {
    return [`/bookings/${id}`] as const;
};

export const getGetBookingQueryOptions = <
    TData = Awaited<ReturnType<typeof getBooking>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBooking>>> = ({ signal }) =>
        getBooking(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBooking>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingQueryResult = NonNullable<Awaited<ReturnType<typeof getBooking>>>;
export type GetBookingQueryError = APIErrorResponseResponse;

/**
 * @summary Get booking by id
 */

export function useGetBooking<
    TData = Awaited<ReturnType<typeof getBooking>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit booking
 */
export const editBooking = (id: number, addEditBookingBodyBody: AddEditBookingBodyBody) => {
    return customInstance<EditBookingSuccessResponseResponse>({
        url: `/bookings/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditBookingBodyBody,
    });
};

export const getEditBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editBooking>>,
        TError,
        { id: number; data: AddEditBookingBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editBooking>>,
    TError,
    { id: number; data: AddEditBookingBodyBody },
    TContext
> => {
    const mutationKey = ['editBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editBooking>>,
        { id: number; data: AddEditBookingBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editBooking(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditBookingMutationResult = NonNullable<Awaited<ReturnType<typeof editBooking>>>;
export type EditBookingMutationBody = AddEditBookingBodyBody;
export type EditBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Edit booking
 */
export const useEditBooking = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editBooking>>,
        TError,
        { id: number; data: AddEditBookingBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editBooking>>,
    TError,
    { id: number; data: AddEditBookingBodyBody },
    TContext
> => {
    const mutationOptions = getEditBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Cancel booking/reservation
 */
export const cancelBooking = (id: number, params?: CancelBookingParams) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}`,
        method: 'DELETE',
        params,
    });
};

export const getCancelBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof cancelBooking>>,
        TError,
        { id: number; params?: CancelBookingParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof cancelBooking>>,
    TError,
    { id: number; params?: CancelBookingParams },
    TContext
> => {
    const mutationKey = ['cancelBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof cancelBooking>>,
        { id: number; params?: CancelBookingParams }
    > = (props) => {
        const { id, params } = props ?? {};

        return cancelBooking(id, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type CancelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBooking>>>;

export type CancelBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Cancel booking/reservation
 */
export const useCancelBooking = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof cancelBooking>>,
        TError,
        { id: number; params?: CancelBookingParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof cancelBooking>>,
    TError,
    { id: number; params?: CancelBookingParams },
    TContext
> => {
    const mutationOptions = getCancelBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Edit booking checkin state
 */
export const editBookingCheckin = (
    id: number,
    editBookingCheckinBodyBody: EditBookingCheckinBodyBody,
    params?: EditBookingCheckinParams,
) => {
    return customInstance<BookingCreateSuccessResponseResponse>({
        url: `/bookings/${id}/checkin`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: editBookingCheckinBodyBody,
        params,
    });
};

export const getEditBookingCheckinMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editBookingCheckin>>,
        TError,
        { id: number; data: EditBookingCheckinBodyBody; params?: EditBookingCheckinParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editBookingCheckin>>,
    TError,
    { id: number; data: EditBookingCheckinBodyBody; params?: EditBookingCheckinParams },
    TContext
> => {
    const mutationKey = ['editBookingCheckin'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editBookingCheckin>>,
        { id: number; data: EditBookingCheckinBodyBody; params?: EditBookingCheckinParams }
    > = (props) => {
        const { id, data, params } = props ?? {};

        return editBookingCheckin(id, data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditBookingCheckinMutationResult = NonNullable<
    Awaited<ReturnType<typeof editBookingCheckin>>
>;
export type EditBookingCheckinMutationBody = EditBookingCheckinBodyBody;
export type EditBookingCheckinMutationError = APIErrorResponseResponse;

/**
 * @summary Edit booking checkin state
 */
export const useEditBookingCheckin = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editBookingCheckin>>,
        TError,
        { id: number; data: EditBookingCheckinBodyBody; params?: EditBookingCheckinParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editBookingCheckin>>,
    TError,
    { id: number; data: EditBookingCheckinBodyBody; params?: EditBookingCheckinParams },
    TContext
> => {
    const mutationOptions = getEditBookingCheckinMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Re-source a booking to a different agent
 */
export const reSourceBooking = (id: number, reSourceBookingBody: ReSourceBookingBody) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}/re-source`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: reSourceBookingBody,
    });
};

export const getReSourceBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reSourceBooking>>,
        TError,
        { id: number; data: ReSourceBookingBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof reSourceBooking>>,
    TError,
    { id: number; data: ReSourceBookingBody },
    TContext
> => {
    const mutationKey = ['reSourceBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof reSourceBooking>>,
        { id: number; data: ReSourceBookingBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return reSourceBooking(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ReSourceBookingMutationResult = NonNullable<
    Awaited<ReturnType<typeof reSourceBooking>>
>;
export type ReSourceBookingMutationBody = ReSourceBookingBody;
export type ReSourceBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Re-source a booking to a different agent
 */
export const useReSourceBooking = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof reSourceBooking>>,
        TError,
        { id: number; data: ReSourceBookingBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof reSourceBooking>>,
    TError,
    { id: number; data: ReSourceBookingBody },
    TContext
> => {
    const mutationOptions = getReSourceBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Refund booking amount without canceling
 */
export const simpleRefundBooking = (
    id: number,
    params?: SimpleRefundBookingParams,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}/simple-refund`,
        method: 'POST',
        params,
        signal,
    });
};

export const getSimpleRefundBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof simpleRefundBooking>>,
        TError,
        { id: number; params?: SimpleRefundBookingParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof simpleRefundBooking>>,
    TError,
    { id: number; params?: SimpleRefundBookingParams },
    TContext
> => {
    const mutationKey = ['simpleRefundBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof simpleRefundBooking>>,
        { id: number; params?: SimpleRefundBookingParams }
    > = (props) => {
        const { id, params } = props ?? {};

        return simpleRefundBooking(id, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type SimpleRefundBookingMutationResult = NonNullable<
    Awaited<ReturnType<typeof simpleRefundBooking>>
>;

export type SimpleRefundBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Refund booking amount without canceling
 */
export const useSimpleRefundBooking = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof simpleRefundBooking>>,
        TError,
        { id: number; params?: SimpleRefundBookingParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof simpleRefundBooking>>,
    TError,
    { id: number; params?: SimpleRefundBookingParams },
    TContext
> => {
    const mutationOptions = getSimpleRefundBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Change tickets in a booking
 */
export const changeBookingItems = (
    id: number,
    changeMassBookingItemsBodyBody: ChangeMassBookingItemsBodyBody,
    params?: ChangeBookingItemsParams,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}/tickets`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: changeMassBookingItemsBodyBody,
        params,
        signal,
    });
};

export const getChangeBookingItemsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof changeBookingItems>>,
        TError,
        { id: number; data: ChangeMassBookingItemsBodyBody; params?: ChangeBookingItemsParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof changeBookingItems>>,
    TError,
    { id: number; data: ChangeMassBookingItemsBodyBody; params?: ChangeBookingItemsParams },
    TContext
> => {
    const mutationKey = ['changeBookingItems'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof changeBookingItems>>,
        { id: number; data: ChangeMassBookingItemsBodyBody; params?: ChangeBookingItemsParams }
    > = (props) => {
        const { id, data, params } = props ?? {};

        return changeBookingItems(id, data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type ChangeBookingItemsMutationResult = NonNullable<
    Awaited<ReturnType<typeof changeBookingItems>>
>;
export type ChangeBookingItemsMutationBody = ChangeMassBookingItemsBodyBody;
export type ChangeBookingItemsMutationError = APIErrorResponseResponse;

/**
 * @summary Change tickets in a booking
 */
export const useChangeBookingItems = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof changeBookingItems>>,
        TError,
        { id: number; data: ChangeMassBookingItemsBodyBody; params?: ChangeBookingItemsParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof changeBookingItems>>,
    TError,
    { id: number; data: ChangeMassBookingItemsBodyBody; params?: ChangeBookingItemsParams },
    TContext
> => {
    const mutationOptions = getChangeBookingItemsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get effective ticket permissions for the current user on a booking
 */
export const getBookingTicketPermissions = (id: number, signal?: AbortSignal) => {
    return customInstance<BookingTicketPermissionsSuccessResponseResponse>({
        url: `/bookings/${id}/ticket-permissions`,
        method: 'GET',
        signal,
    });
};

export const getGetBookingTicketPermissionsQueryKey = (id?: number) => {
    return [`/bookings/${id}/ticket-permissions`] as const;
};

export const getGetBookingTicketPermissionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getBookingTicketPermissions>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getBookingTicketPermissions>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingTicketPermissionsQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingTicketPermissions>>> = ({
        signal,
    }) => getBookingTicketPermissions(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBookingTicketPermissions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingTicketPermissionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getBookingTicketPermissions>>
>;
export type GetBookingTicketPermissionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get effective ticket permissions for the current user on a booking
 */

export function useGetBookingTicketPermissions<
    TData = Awaited<ReturnType<typeof getBookingTicketPermissions>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getBookingTicketPermissions>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingTicketPermissionsQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Send seating assignment changed email for a single booking
 */
export const sendBookingSeatingChangedEmail = (id: number, signal?: AbortSignal) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/bookings/${id}/seating-changed-email`,
        method: 'POST',
        signal,
    });
};

export const getSendBookingSeatingChangedEmailMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['sendBookingSeatingChangedEmail'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return sendBookingSeatingChangedEmail(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendBookingSeatingChangedEmailMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>
>;

export type SendBookingSeatingChangedEmailMutationError = APIErrorResponseResponse;

/**
 * @summary Send seating assignment changed email for a single booking
 */
export const useSendBookingSeatingChangedEmail = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendBookingSeatingChangedEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getSendBookingSeatingChangedEmailMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Connect to FareHarbor via agent service and discover items + seat maps
 */
export const fhDirectConnect = (fhDirectConnectBody: FhDirectConnectBody, signal?: AbortSignal) => {
    return customInstance<FhDirectConnect200>({
        url: `/bookings/import/fareharbor-direct/connect`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectConnectBody,
        signal,
    });
};

export const getFhDirectConnectMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectConnect>>,
        TError,
        { data: FhDirectConnectBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectConnect>>,
    TError,
    { data: FhDirectConnectBody },
    TContext
> => {
    const mutationKey = ['fhDirectConnect'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectConnect>>,
        { data: FhDirectConnectBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectConnect(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectConnectMutationResult = NonNullable<
    Awaited<ReturnType<typeof fhDirectConnect>>
>;
export type FhDirectConnectMutationBody = FhDirectConnectBody;
export type FhDirectConnectMutationError = APIErrorResponseResponse;

/**
 * @summary Connect to FareHarbor via agent service and discover items + seat maps
 */
export const useFhDirectConnect = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectConnect>>,
        TError,
        { data: FhDirectConnectBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectConnect>>,
    TError,
    { data: FhDirectConnectBody },
    TContext
> => {
    const mutationOptions = getFhDirectConnectMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Fetch booking manifest for a date range from FareHarbor
 */
export const fhDirectManifest = (
    fhDirectManifestBody: FhDirectManifestBody,
    signal?: AbortSignal,
) => {
    return customInstance<FhDirectManifest200>({
        url: `/bookings/import/fareharbor-direct/manifest`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectManifestBody,
        signal,
    });
};

export const getFhDirectManifestMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectManifest>>,
        TError,
        { data: FhDirectManifestBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectManifest>>,
    TError,
    { data: FhDirectManifestBody },
    TContext
> => {
    const mutationKey = ['fhDirectManifest'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectManifest>>,
        { data: FhDirectManifestBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectManifest(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectManifestMutationResult = NonNullable<
    Awaited<ReturnType<typeof fhDirectManifest>>
>;
export type FhDirectManifestMutationBody = FhDirectManifestBody;
export type FhDirectManifestMutationError = APIErrorResponseResponse;

/**
 * @summary Fetch booking manifest for a date range from FareHarbor
 */
export const useFhDirectManifest = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectManifest>>,
        TError,
        { data: FhDirectManifestBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectManifest>>,
    TError,
    { data: FhDirectManifestBody },
    TContext
> => {
    const mutationOptions = getFhDirectManifestMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Discover FH items and their customer type rates via availability API
 */
export const fhDirectDiscoverItems = (
    fhDirectDiscoverItemsBody: FhDirectDiscoverItemsBody,
    signal?: AbortSignal,
) => {
    return customInstance<FhDirectDiscoverItems200>({
        url: `/bookings/import/fareharbor-direct/discover-items`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectDiscoverItemsBody,
        signal,
    });
};

export const getFhDirectDiscoverItemsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectDiscoverItems>>,
        TError,
        { data: FhDirectDiscoverItemsBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectDiscoverItems>>,
    TError,
    { data: FhDirectDiscoverItemsBody },
    TContext
> => {
    const mutationKey = ['fhDirectDiscoverItems'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectDiscoverItems>>,
        { data: FhDirectDiscoverItemsBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectDiscoverItems(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectDiscoverItemsMutationResult = NonNullable<
    Awaited<ReturnType<typeof fhDirectDiscoverItems>>
>;
export type FhDirectDiscoverItemsMutationBody = FhDirectDiscoverItemsBody;
export type FhDirectDiscoverItemsMutationError = APIErrorResponseResponse;

/**
 * @summary Discover FH items and their customer type rates via availability API
 */
export const useFhDirectDiscoverItems = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectDiscoverItems>>,
        TError,
        { data: FhDirectDiscoverItemsBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectDiscoverItems>>,
    TError,
    { data: FhDirectDiscoverItemsBody },
    TContext
> => {
    const mutationOptions = getFhDirectDiscoverItemsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Import bookings from FareHarbor (accepts UUIDs from manifest)
 */
export const fhDirectImport = (fhDirectImportBody: FhDirectImportBody, signal?: AbortSignal) => {
    return customInstance<FhDirectImport200>({
        url: `/bookings/import/fareharbor-direct/import`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectImportBody,
        signal,
    });
};

export const getFhDirectImportMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectImport>>,
        TError,
        { data: FhDirectImportBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectImport>>,
    TError,
    { data: FhDirectImportBody },
    TContext
> => {
    const mutationKey = ['fhDirectImport'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectImport>>,
        { data: FhDirectImportBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectImport(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectImportMutationResult = NonNullable<Awaited<ReturnType<typeof fhDirectImport>>>;
export type FhDirectImportMutationBody = FhDirectImportBody;
export type FhDirectImportMutationError = APIErrorResponseResponse;

/**
 * @summary Import bookings from FareHarbor (accepts UUIDs from manifest)
 */
export const useFhDirectImport = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectImport>>,
        TError,
        { data: FhDirectImportBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectImport>>,
    TError,
    { data: FhDirectImportBody },
    TContext
> => {
    const mutationOptions = getFhDirectImportMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Verify imported bookings against a FareHarbor CSV export
 */
export const fhDirectVerify = (fhDirectVerifyBody: FhDirectVerifyBody, signal?: AbortSignal) => {
    return customInstance<FhDirectVerify200>({
        url: `/bookings/import/fareharbor-direct/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectVerifyBody,
        signal,
    });
};

export const getFhDirectVerifyMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectVerify>>,
        TError,
        { data: FhDirectVerifyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectVerify>>,
    TError,
    { data: FhDirectVerifyBody },
    TContext
> => {
    const mutationKey = ['fhDirectVerify'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectVerify>>,
        { data: FhDirectVerifyBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectVerify(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof fhDirectVerify>>>;
export type FhDirectVerifyMutationBody = FhDirectVerifyBody;
export type FhDirectVerifyMutationError = APIErrorResponseResponse;

/**
 * @summary Verify imported bookings against a FareHarbor CSV export
 */
export const useFhDirectVerify = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectVerify>>,
        TError,
        { data: FhDirectVerifyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectVerify>>,
    TError,
    { data: FhDirectVerifyBody },
    TContext
> => {
    const mutationOptions = getFhDirectVerifyMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Apply fixes for verified import mismatches
 */
export const fhDirectVerifyFix = (
    fhDirectVerifyFixBody: FhDirectVerifyFixBody,
    signal?: AbortSignal,
) => {
    return customInstance<FhDirectVerifyFix200>({
        url: `/bookings/import/fareharbor-direct/verify-fix`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectVerifyFixBody,
        signal,
    });
};

export const getFhDirectVerifyFixMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectVerifyFix>>,
        TError,
        { data: FhDirectVerifyFixBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectVerifyFix>>,
    TError,
    { data: FhDirectVerifyFixBody },
    TContext
> => {
    const mutationKey = ['fhDirectVerifyFix'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectVerifyFix>>,
        { data: FhDirectVerifyFixBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectVerifyFix(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectVerifyFixMutationResult = NonNullable<
    Awaited<ReturnType<typeof fhDirectVerifyFix>>
>;
export type FhDirectVerifyFixMutationBody = FhDirectVerifyFixBody;
export type FhDirectVerifyFixMutationError = APIErrorResponseResponse;

/**
 * @summary Apply fixes for verified import mismatches
 */
export const useFhDirectVerifyFix = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectVerifyFix>>,
        TError,
        { data: FhDirectVerifyFixBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectVerifyFix>>,
    TError,
    { data: FhDirectVerifyFixBody },
    TContext
> => {
    const mutationOptions = getFhDirectVerifyFixMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Import seat map from FareHarbor into show seats
 */
export const fhDirectImportSeats = (
    fhDirectImportSeatsBody: FhDirectImportSeatsBody,
    signal?: AbortSignal,
) => {
    return customInstance<FhDirectImportSeats200>({
        url: `/bookings/import/fareharbor-direct/import-seats`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: fhDirectImportSeatsBody,
        signal,
    });
};

export const getFhDirectImportSeatsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectImportSeats>>,
        TError,
        { data: FhDirectImportSeatsBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof fhDirectImportSeats>>,
    TError,
    { data: FhDirectImportSeatsBody },
    TContext
> => {
    const mutationKey = ['fhDirectImportSeats'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof fhDirectImportSeats>>,
        { data: FhDirectImportSeatsBody }
    > = (props) => {
        const { data } = props ?? {};

        return fhDirectImportSeats(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FhDirectImportSeatsMutationResult = NonNullable<
    Awaited<ReturnType<typeof fhDirectImportSeats>>
>;
export type FhDirectImportSeatsMutationBody = FhDirectImportSeatsBody;
export type FhDirectImportSeatsMutationError = APIErrorResponseResponse;

/**
 * @summary Import seat map from FareHarbor into show seats
 */
export const useFhDirectImportSeats = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof fhDirectImportSeats>>,
        TError,
        { data: FhDirectImportSeatsBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof fhDirectImportSeats>>,
    TError,
    { data: FhDirectImportSeatsBody },
    TContext
> => {
    const mutationOptions = getFhDirectImportSeatsMutationOptions(options);

    return useMutation(mutationOptions);
};
